import script from "./MyProfileStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfileStudent.vue?vue&type=script&setup=true&lang=js"

import "./MyProfileStudent.vue?vue&type=style&index=0&id=9e4dd342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e4dd342"]])

export default __exports__